/**
 * Textos (`ca`) del tall «planta» de Qualitat i APPCC: el que l'App de planta diu del control de qualitat a la
 * recepció (OBR-167). Cada namespace d'aquest fitxer és AUTOCONTINGUT (`planta.qualityReception`, i els que hi
 * afegeixin els altres talls: autocontrols, no conformitats). Tall propi: no es toca `ca.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const plantaCa = {
  'planta.qualityReception': {
    // ── Bloc de control de qualitat d'una entrada ─────────────────────────────────────
    title: 'Control de qualitat',
    temperature: 'Temperatura (°C)',
    temperatureRequired: 'Temperatura (°C), obligatòria',
    temperaturePlaceholder: 'Per exemple 3,5',
    temperatureRange: 'Rang acceptable: {{range}}',
    rangeBetween: '{{min}} a {{max}} °C',
    rangeAtLeast: 'Mínim {{min}} °C',
    rangeAtMost: 'Màxim {{max}} °C',
    signToggle: 'Canvia el signe: positiu o negatiu',
    status_ok: 'Dins del rang',
    status_low: 'Per sota del mínim',
    status_high: 'Per sobre del màxim',
    temperatureMissing: 'Cal anotar la temperatura.',
    temperatureUnreadable: 'Escriu una temperatura vàlida.',
    packaging: 'Envàs',
    labeling: 'Etiquetatge',
    checkOk: 'OK',
    checkKo: 'KO',
    issuesNotice: 'Alguna cosa no quadra: {{list}}. Es registrarà una no conformitat.',
    issue_temperature_out_of_range: 'temperatura fora de rang',
    issue_packaging_ko: 'envàs en mal estat',
    issue_labeling_ko: 'etiquetatge incorrecte',
    decision: 'Què en fas?',
    decision_accepted: 'Accepta',
    decision_accepted_with_incident: 'Accepta amb incidència',
    decision_rejected: 'Rebutja',
    decisionMissing: 'Tria què en fas.',
    rejectedHint:
      'Rebutjar el gènere el bloqueja a les existències: no es podrà gastar i quedarà pendent de tornar.',
    derivedNok: 'No conforme pel control',

    // ── Pantalla de recepció ──────────────────────────────────────────────────────────
    lineNeedsQuality: 'Falta el control',
    qualityMissingSummary: 'Falta la temperatura o què fas amb el gènere en alguna entrada.',
    supplierNotApproved: 'Aquest proveïdor no està homologat.',
    supplierSuspended: 'Aquest proveïdor està suspès.',
    supplierWarningHint: 'Pots rebre el gènere igualment: la recepció queda registrada i es revisarà.',

    // ── Detall de la recepció ─────────────────────────────────────────────────────────
    detailTemperature: 'Temperatura: {{value}} °C',
    detailPackaging: 'Envàs: {{status}}',
    detailLabeling: 'Etiquetatge: {{status}}',
    detailDecision: 'Decisió: {{decision}}',
  },

  'planta.selfChecks': {
    // ── Targeta de l’inici d’Ordres i pantalla de Qualitat ─────────────────────────────
    title: 'Qualitat',
    cardTitle: 'Autocontrols d’avui',
    cardPending_one: '{{count}} autocontrol pendent',
    cardPending_other: '{{count}} autocontrols pendents',
    cardAllDone: 'Tots els autocontrols són fets.',
    cardSeeAll: 'Veure-ho tot',
    cardOpen: 'Fes l’autocontrol: {{name}}',
    dueSection: 'Pendents',
    doneSection: 'Fets',
    noneDue: 'Tot fet per ara.',
    noTemplates: 'L’obrador encara no té autocontrols. Es configuren al BackOffice, a Qualitat.',
    duePeriod_daily: 'Avui',
    duePeriod_weekly: 'Aquesta setmana',
    duePeriod_monthly: 'Aquest mes',
    kind_cleaning: 'Neteja i desinfecció',
    kind_temperature: 'Temperatures',
    kind_pests: 'Control de plagues',
    kind_custom: 'Altres',
    frequency_daily: 'Diària',
    frequency_weekly: 'Setmanal',
    frequency_monthly: 'Mensual',
    resultOk: 'OK',
    resultKo: 'KO',
    doneAt: 'Fet a les {{time}}',
    pendingSync: 'Pendent d’enviar',
    webUnsupported: 'Els autocontrols es fan des de l’app del mòbil.',

    // ── Omplir un autocontrol ─────────────────────────────────────────────────────────
    instructionsTitle: 'Com es fa',
    markAllOk: 'Marca OK els que falten',
    checkOk: 'OK',
    checkKo: 'KO',
    requiredTag: 'obligatori',
    fieldMissing: 'Falta omplir aquest camp.',
    numberPlaceholder: 'Per exemple 3,5',
    numberUnreadable: 'Escriu un número vàlid.',
    numberRange: 'Rang acceptable: {{range}}',
    rangeBetween: '{{min}} a {{max}}{{unit}}',
    rangeAtLeast: 'Mínim {{min}}{{unit}}',
    rangeAtMost: 'Màxim {{max}}{{unit}}',
    signToggle: 'Canvia el signe: positiu o negatiu',
    status_in_range: 'Dins del rang',
    status_out_of_range: 'Fora de rang',
    textPlaceholder: 'Escriu-ho aquí',
    photoTake: 'Fes una foto',
    photoRetake: 'Torna-la a fer',
    photoRemove: 'Treu-la',
    photoAttached: 'Foto adjuntada',
    photoPendingUpload: 'Es pujarà quan hi hagi connexió.',
    photoPermissionDenied: 'Cal donar permís per fer servir la càmera.',
    recordPhoto: 'Foto de l’autocontrol (opcional)',
    notes: 'Notes de l’autocontrol (opcional)',
    notesPlaceholder: 'Qualsevol cosa que calgui deixar escrita',
    issuesNotice: 'Alguna cosa no quadra: {{list}}. S’obrirà una no conformitat.',
    issueItemKo: '{{label}} en KO',
    issueItemRange: '{{label}} fora de rang ({{value}}{{unit}})',
    missingSummary: 'Falta omplir: {{list}}.',
    save: 'Desa',
    saving: 'Desant…',
    saveFailed: 'No s’ha pogut desar. Torna-ho a provar.',

    // ── Desat, ja fet, no trobat ──────────────────────────────────────────────────────
    saved: 'Autocontrol desat',
    savedKo: 'Desat. S’obrirà una no conformitat quan arribi al servidor.',
    savedHint: 'Sense connexió, s’enviarà sol quan la tornis a tenir.',
    nextCheck: 'Següent autocontrol',
    nextCheckName: 'Pendent: {{name}}',
    backToList: 'Torna a Qualitat',
    alreadyDoneTitle: 'Ja és fet',
    alreadyDoneBody: 'Aquest autocontrol ja consta com a fet en aquest període ({{result}}).',
    notFoundTitle: 'No s’ha trobat l’autocontrol',
    notFoundBody: 'Potser s’ha donat de baixa. Torna a la llista.',
  },

  'planta.nonConformities': {
    reportCta: 'Comunica una no conformitat',
    title: 'Comunica una no conformitat',
    intro: 'Explica què has vist. Queda registrat ara, també sense connexió.',
    description: 'Què ha passat?',
    descriptionPlaceholder: 'Per exemple: caixa de llet trencada al moll',
    descriptionMissing: 'Explica què ha passat.',
    relatedTitle: 'Relacionada amb (opcional)',
    supplier: 'Proveïdor',
    article: 'Article',
    pickSupplier: 'Tria un proveïdor',
    pickArticle: 'Tria un article',
    change: 'Canvia',
    clear: 'Treu',
    search: 'Cerca per nom o codi',
    noMatch: 'Cap resultat.',
    noSuppliers: 'Encara no hi ha proveïdors en aquest aparell.',
    noArticles: 'Encara no hi ha articles en aquest aparell.',
    close: 'Tanca',
    photo: 'Foto (opcional)',
    photoTake: 'Fes una foto',
    photoRetake: 'Torna-la a fer',
    photoRemove: 'Treu-la',
    photoAttached: 'Foto adjuntada',
    photoPendingUpload: 'Es pujarà quan hi hagi connexió.',
    photoPermissionDenied: 'Cal donar permís per fer servir la càmera.',
    save: 'Comunica',
    saving: 'Enviant…',
    saveFailed: 'No s’ha pogut comunicar. Torna-ho a provar.',
    saved: 'No conformitat comunicada',
    savedBody: 'Queda registrada i es revisarà. Rebrà el seu codi NC quan arribi al servidor.',
    reportAnother: 'Comunica’n una altra',
    backToQuality: 'Torna a Qualitat',
    historyTitle: 'Comunicades des d’aquest aparell',
    historyEmpty: 'Encara no n’has comunicat cap.',
    codePending: 'Pendent d’enviar',
    statusRejected: 'No s’ha pogut enviar',
    withPhoto: 'Amb foto',
    webUnsupported: 'Les no conformitats es comuniquen des de l’app del mòbil.',
  },
} as const;
